// Module
var code = "<div class=\"row\"> <h1> Training Tracking (Compl.) </h1> </div>";
// Exports
module.exports = code;